import { useState } from 'react'
import { handlePostRequest } from '../../utils/api-handler.util'
import { useParams } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { useMutation } from '@tanstack/react-query'
import { showToaster } from '../../utils/show-toaster.util'
import { PaperAirplaneIcon } from '@heroicons/react/24/outline'
import { QueryKeys } from '../../utils/queryKeyGenerator'

export default function NewMessageInput({ handleScroll }) {
  const [message, setMessage] = useState('')
  const { conversationId } = useParams()
  const { currentUser } = useAuth()

  const sendMessageMutation = useMutation({
    mutationFn: () =>
      handlePostRequest(`/${currentUser.userType}s/messages/send`, {
        conversationId,
        message,
        senderId: currentUser.id,
      }),
    onSuccess: () => {
      setMessage('')
      QueryKeys.listConversationMessages.invalidate(conversationId, currentUser.userType)
      handleScroll()
    },
    onError: (error) => {
      console.error('Error sending message:', error)
      showToaster('Failed to send message', 'error')
    },
  })

  const handleSendMessage = async () => {
    if (!message.trim()) return
    // const shouldAutoScroll = isNearBottom(scrollContainerRef)
    await sendMessageMutation.mutateAsync({ message })
  }

  return (
    <div className="border-t bg-background p-3 sticky bottom-0 z-10 pb-[env(safe-area-inset-bottom)]">
      <div className="flex items-center space-x-2">
        <input
          type="text"
          placeholder="Type a message..."
          className="flex-1 border rounded-full px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !sendMessageMutation.isLoading) {
              e.preventDefault()
              handleSendMessage()
            }
          }}
          disabled={sendMessageMutation.isLoading}
        />
        <button
          className={`p-3 rounded-full ${
            sendMessageMutation.isLoading
              ? 'bg-orange-300 cursor-wait'
              : 'bg-orange-500 hover:bg-orange-600'
          }`}
          onClick={handleSendMessage}
          disabled={sendMessageMutation.isLoading || !message.trim()}
        >
          <PaperAirplaneIcon className="w-5 h-5 text-white transform rotate-50" />
        </button>
      </div>
    </div>
  )
}
